import { usePeriod } from '../hooks/usePeriod.jsx';
import { formatMonth } from '../lib/format.js';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MODES = ['month', 'quarter', 'year'];
const MODE_LABELS = { month: 'Mois', quarter: 'Trimestre', year: 'Année' };

export default function PeriodSwitcher() {
  const { period, setPeriod } = usePeriod();

  function prevPeriod() {
    setPeriod((prev) => {
      if (prev.mode === 'year') {
        return { ...prev, year: prev.year - 1 };
      }
      if (prev.mode === 'quarter') {
        const qStart = Math.floor((prev.month - 1) / 3) * 3 + 1;
        const prevQ = qStart - 3;
        if (prevQ < 1) return { ...prev, year: prev.year - 1, month: 10 };
        return { ...prev, month: prevQ };
      }
      if (prev.month === 1) return { ...prev, year: prev.year - 1, month: 12 };
      return { ...prev, month: prev.month - 1 };
    });
  }

  function nextPeriod() {
    setPeriod((prev) => {
      if (prev.mode === 'year') {
        return { ...prev, year: prev.year + 1 };
      }
      if (prev.mode === 'quarter') {
        const qStart = Math.floor((prev.month - 1) / 3) * 3 + 1;
        const nextQ = qStart + 3;
        if (nextQ > 12) return { ...prev, year: prev.year + 1, month: 1 };
        return { ...prev, month: nextQ };
      }
      if (prev.month === 12) return { ...prev, year: prev.year + 1, month: 1 };
      return { ...prev, month: prev.month + 1 };
    });
  }

  function periodLabel() {
    if (period.mode === 'year') return `${period.year}`;
    if (period.mode === 'quarter') {
      const q = Math.ceil(period.month / 3);
      return `T${q} ${period.year}`;
    }
    return formatMonth(period.year, period.month);
  }

  return (
    <div className="flex items-center gap-2">
      <div className="flex rounded-lg border border-slate-200 overflow-hidden text-xs">
        {MODES.map((m) => (
          <button
            key={m}
            onClick={() => setPeriod((p) => ({ ...p, mode: m }))}
            className={`px-3 py-1.5 font-medium transition-colors ${
              period.mode === m
                ? 'bg-slate-800 text-white'
                : 'bg-white text-slate-600 hover:bg-slate-50'
            }`}
          >
            {MODE_LABELS[m]}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={prevPeriod}
          className="p-1.5 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors"
          aria-label="Période précédente"
        >
          <ChevronLeft size={16} />
        </button>
        <span className="text-sm font-medium text-slate-700 min-w-[110px] text-center capitalize">
          {periodLabel()}
        </span>
        <button
          onClick={nextPeriod}
          className="p-1.5 rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors"
          aria-label="Période suivante"
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
